import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type UnikeyCurrencyDTO = z.infer<typeof UnikeyCurrencyDTORuntype>;
export const UnikeyCurrencyDTORuntype = z.enum(['USD', 'CNY', 'CNYNoTax']);

export interface UnikeyCredentialsDTO extends z.infer<typeof UnikeyCredentialsDTORuntype> {}
export const UnikeyCredentialsDTORuntype = z.object({
    appid: z.string(),
    appkey: z.string(),
    currency: UnikeyCurrencyDTORuntype,
});

export interface UnikeyCredentialsInputDTO extends z.infer<typeof UnikeyCredentialsInputDTORuntype> {}
export const UnikeyCredentialsInputDTORuntype = z.object({
    appid: z.string().optional(),
    appkey: z.string().optional(),
    currency: UnikeyCurrencyDTORuntype.optional(),
});

export interface UnikeyResponseBodyDTO extends z.infer<typeof UnikeyResponseBodyDTORuntype> {}
export const UnikeyResponseBodyDTORuntype = z.object({
    data: UnikeyCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
